"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const storeLocatorInputs = [
  {
    name: "defaultLatitude",
    type: "number",
    required: true,
    defaultValue: 0,
  },
  {
    name: "defaultLongitude",
    type: "number",
    required: true,
    defaultValue: 0,
  },
  {
    name: "storesLimit",
    type: "number",
    defaultValue: 0,
  },
  {
    name: "filtersEnabled",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "defaultZoom",
    type: "number",
    defaultValue: 15,
  },
  {
    name: "storeLocatorDetailsPageUrl",
    type: "url",
  },
  {
    name: "storeDetailsPageTarget",
    type: "string",
    enum: ["sameTab", "newTab"],
    defaultValue: "_blank",
  },
  {
    name: "isOpeningHoursEnabled",
    type: "boolean",
    defaultValue: false,
    friendlyName: "Show shop opening hours",
  },
  {
    name: "isOpeningHoursBreaksEnabled",
    type: "boolean",
    defaultValue: false,
    friendlyName: "Show shop opening hours with breaks",
  },
  {
    name: "isAvailableDevicesEnabled",
    type: "boolean",
    defaultValue: false,
    friendlyName: "Show available device colors",
  },
  {
    name: "isAvailableSticksEnabled",
    type: "boolean",
    defaultValue: false,
    friendlyName: "Show available stick flavours",
  },
  {
    name: "isMapInteractionEnabled",
    type: "boolean",
    defaultValue: false,
    friendlyName:
      "Toggles hiding the search bar during map interactions on mobile",
  },
  {
    name: "defaultStoreIcon",
    type: "file",
    friendlyName: "Brand store icon",
    allowedFileTypes: ["svg"],
  },
  {
    name: "filtersTranslations",
    type: "list",
    subFields: [
      {
        name: "filterKey",
        type: "string",
        required: true,
      },
      {
        name: "translatedFilterKey",
        type: "string",
        required: true,
      },
    ],
  },
] as const satisfies Inputs;

export const StoreLocatorComponent: RegisteredComponent = {
  name: "StoreLocator",
  component: dynamic(
    async () =>
      withValidation(
        storeLocatorInputs,
        (await import("./StoreLocator")).StoreLocator,
        "StoreLocator"
      ),
    { ssr: false }
  ),
  inputs: storeLocatorInputs,
};
